export default "__VITE_ASSET__804fecf8__"